<template>
  <v-card width="100%" rounded="0" flat height="100%">
    <v-sheet color="grey-lighten-2" class="px-1 mb-1 d-flex justify-space-between align-center">
      {{ month.name }}
      <v-spacer />
      <v-chip variant="text" size="small" style="opacity: 0.3;" v-if="true">
        {{ month.hours.used }} / {{ free_time }} ({{ month.hours.all }})
      </v-chip>
    </v-sheet>
    <template v-for="(day, index) of month.days" :key="day">
      <v-divider class="my-0" color="black" />
      <v-sheet :id="day.id" style="position: relative" :color="check_day(day) ? 'rgba(210,210,210,0.48)' : 'transparent'" class="d-flex justify-start align-center px-1" v-on:click="editable ? add_docs(day, month) : null">
        <v-sheet width="10px" class="d-flex justify-center align-center mr-1" color="transparent">
          <span class="font-weight-bold" :style="`color: ${ get_wd_color(day.weekday, day.type) }`" style="font-size: 10px; rotate: -90deg">
            {{ get_week_day(day.weekday) }}
          </span>
        </v-sheet>
        <v-sheet class="d-flex justify-space-between align-center text-center font-weight-bold" :color="get_color(day.type)">
          <span class="mx-1">{{ moment(day.date).format('DD') }}</span>
        </v-sheet>
        <v-sheet class="d-flex justify-space-between align-center text-center" color="transparent">
          <template v-if="day.documents && day.documents.length <= size">
            <ZN_Chip v-for="doc in day.documents" :key="doc" :doc="doc" :day="day" :editable="editable"/>
          </template>
          <template v-else>
            <ZN_Chip v-for="doc in day.documents" :key="doc" :doc="doc" :day="day" :editable="editable"/>

            <v-menu open-on-hover v-if="false">
              <template v-slot:activator="{ props }">
                <v-chip v-bind="props" density="compact" variant="text" class="font-weight-bold" style="cursor: pointer">
                  + {{ day.documents.length-size }}
                </v-chip>
              </template>

              <v-card rounded="xl" elevation="5" density="compact" color="white">
                <template v-slot:text>
                  <v-sheet class="d-flex flex-column justify-space-between" color="transparent">
                    <ZN_Chip :doc="doc" :day="day" v-for="doc in day.documents.slice(size)" :key="doc"/>
                  </v-sheet>
                </template>
              </v-card>
            </v-menu>
          </template>
        </v-sheet>
        <v-sheet color="transparent" width="100%" class="text-center" style="position: absolute; top: 0; left: 0; z-index: -1" v-if="day.holidays && !(day.documents && day.documents.length > 0)">
          <template v-for="(holiday, index) in day.holidays" :key="holiday">
            <v-chip  variant="text" density="compact" class="mb-1" :class="{'mr-1' : index+1 !== day.holidays.length}" v-if="holiday.event_type !== 'рабочий'">
              {{ holiday.name }}
              <v-avatar v-if="get_image(holiday.region)" class="ml-2" size="15" rounded="sm" :image="get_image(holiday.region)" />
            </v-chip>
          </template>

        </v-sheet>
        <v-sheet color="transparent" width="100%" class="text-center" style="position: absolute; top: 0; left: 0; z-index: -1" v-if="day.documents.length === 0 && $config.GOOSE && moment(day.date).format('DD.MM.YYYY') === `22.11.${year}`">
          <v-avatar :image="'https://media.tenor.com/j0qPYTg9a94AAAAi/duck-ducky.gif'" size="25" style="margin-top: -6px; opacity: 0.5" />
        </v-sheet>
        <v-spacer />
        <v-sheet class="d-flex justify-center align-center" color="transparent">
          <v-chip :color="get_overdraft_color(day)" variant="text" density="compact" size="small" class="font-weight-bold" style="opacity: 0.5;">
            <span>{{ used_hours(day) }} /
              <span>
                {{ day.hours.all }}
                <v-tooltip activator="parent" class="ma-0 ma-0">
                  {{ getWord(day.hours.free.toFixed(0)) }}<br>
                  *Всего часов: {{ day.hours.modified.toFixed(0) }}
                </v-tooltip>
              </span>
            </span>
          </v-chip>
        </v-sheet>
      </v-sheet>
      <v-divider v-if="index+1 === month.days.length" class="my-0" color="black" />
    </template>
  </v-card>
</template>

<script>
 import ZN_Chip from "@/components/zn_planner/ZN_Chip.vue"
import moment from "moment"
import { Documents, SelectedDocs } from "@/store/zn_planner/Documents"
import { CurrentYearCalendar } from "@/store/zn_planner/CalendarOfYear"
import { Allerts } from "@/store/global/Allerts"

export default {
  name: "ZN_MonthCard",
  components: { ZN_Chip },
  props: ['month', 'year', 'editable'],
  data() {
    return {
      size: 2
    }
  },
  computed: {
    free_time() {
      return this.month.hours.modified
    },
    calendar: {
      get() {
        return CurrentYearCalendar().get()
      },
      set(value) {
        CurrentYearCalendar().set(value)
      }
    },
    selected: {
      get() {
        return SelectedDocs().get()
      },
      set(value) {
        SelectedDocs().set(value)
      }
    },
    documents: {
      get() {
        return Documents().get()
      },
      set(value) {
        Documents().set(value)
      }
    }
  },
  methods: {
    moment,
    used_hours: function (day) {
      let hours = 0
      day.documents.forEach(doc => {
        hours += doc.duration
      })
      return hours.toFixed(0)
    },
    getWord: function (hours) {
      if (hours < 0) {
        return `НЕДОСТАТОК ${hours*-1} ч.`
      } else if (hours > 0) {
        return `СВОБОДНО ${hours} ч.`
      } else {
        return 'СВОБОДНОГО МЕСТА НЕТ'
      }
    },
    clear_day: function (day) {
      for (let doc in day.documents) {
        this.documents.unshift(doc)
      }

      day.documents = []
      day.hours.used = 0
    },
    get_image: function (region) {
      if (this.calendar.special.region.guid && this.calendar.special.region.guid === region) {
        return this.calendar.special.region.image
      }
      return 'https://media.scgrdn.pro/global/regions/flags/russian_flag.webp'
    },
    add_docs: function (day, month) {
      if (this.selected.length > 0) {
        if (day.type !== 'Праздник') {
          if (day.weekday === 6 || day.weekday === 7) {
            Allerts().warn('ВНИМАНИЕ', 'Вы поставили работы на выходной день!', '#f1a602', 'triangle-exclamation')
          }
          day.documents = day.documents.concat(this.selected)
          this.selected.map(doc => {
            this.documents.splice(this.documents.findIndex(d => d.guid === doc.guid), 1)
            day.hours.used += doc.duration
            day.hours.free -= doc.duration
            month.hours.used += doc.duration
          })
          this.selected = []
        } else {
          Allerts().warn('ТАК НЕЛЬЗЯ', 'Работать в праздничный день не рекомендуется!', '#f1a602', 'skull-crossbones')
        }
      }
    },
    check_day: function (day) {
      return moment(day.date).format('DD.MM.YYYY') === moment().format('DD.MM.YYYY')
    },
    get_week_day: function (day) {
      switch (day) {
        case 1: return 'ПН'
        case 2: return 'ВТ'
        case 3: return 'СР'
        case 4: return 'ЧТ'
        case 5: return 'ПТ'
        case 6: return 'СБ'
        case 7: return 'ВС'
      }
    },
    get_color: function (type) {
      switch (type) {
        case 'Обычный':               return 'transparent'
        case 'ПринудительноРабочий':  return 'transparent'
        case 'Предпраздничный':       return 'deep-orange-lighten-4'
        case 'Праздник':              return 'deep-orange-lighten-3'
        default:                      return 'black'
      }
    },
    get_overdraft_color: function (day) {
      let color = 'transparent'
      if (day.type === 'Праздник') {
        color = 'transparent'
      } else {
        if (day.hours.all === 0 && this.used_hours(day) === 0) {
          color = 'transparent'
        } else if (this.used_hours(day) === 0) {
          if (this.documents.length === 0) {
            color = 'rgb(255,0,0)'
          } else {
            color = 'rgba(0,0,0,.3)'
          }
        } else {
          let percent = (this.used_hours(day) / day.hours.modified) * 100
          if (percent === 0) {
            color = 'rgba(0,0,0,.3)'
          }  else if (percent > 0 && percent < 90) {
            color = '#a8d753'
          } else if (percent >= 90 && percent <= 100) {
            color = '#6b9f0a'
          } else if (percent > 100 && percent < 120) {
            color = '#fa7100'
          } else if (percent >= 120 && percent < 150) {
            color = '#da4828'
          } else {
            color = '#671b0b'
          }
        }
      }
      return color
    },
    get_wd_color: function (position, type) {

      if (type === 'ПринудительноРабочий') {
        return '#282828'
      } else {
        switch (position) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5: return '#282828'
          case 6:
          case 7: return '#f17979'
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
